import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WorkbenchModule } from '@workbench/angular';
import { TranslationService } from '../../../services/translation.service';
import { CountrySelectionService } from '../../../services/country-selection/country-selection.service';


@Component({
    selector: 'app-country-selector',
    standalone: true,
    imports: [WorkbenchModule, TranslateModule],
    templateUrl: './country-selector.component.html',
    styleUrl: './country-selector.component.scss',
})
export class CountrySelectorComponent implements OnInit {


    public countryList: any[] = [{ title: '', code: '' }];
    public hasUserConfirmedCountry: boolean = false;
    public userOriginCountry = '';
    isSelectedCountrySupported: boolean = false;
    isLoginRedirectionInProgress: boolean = false;

    @ViewChild('imageBackground') imageBackground: ElementRef | undefined;
    constructor(private readonly _countrySelectionService: CountrySelectionService, private readonly _translationService: TranslationService ) { }

    ngOnInit(): void {
        if (localStorage.getItem('countryOfOrigin')) {
            return;
        }
        this.countryList = this._translationService.cpConfig.countries
            .map((country: any) => {
                return {
                    title: country.name,
                    code: country.code,
                    region: country.region,
                    isSupported: country.flag,
                    default: country.default,
                };
            });
    }

    selectCountry(e: any): void {
        this.isLoginRedirectionInProgress = false;
        this.isSelectedCountrySupported = false;

        let selectedCode = '';
        let selectedLabel = '';

        // 1. Prefer the selected list item element in the DOM.
        const listEl: HTMLElement = e?.detail?.source ?? e?.target ?? e?.currentTarget;
        if (listEl) {
            const selectedItem = Array.from(listEl.querySelectorAll('wb-combobox-list-item'))
                .find((item: any) => item.selected || item.getAttribute('selected')) as any;
            if (selectedItem) {
                selectedCode = selectedItem.value ?? selectedItem.getAttribute?.('value') ?? '';
                selectedLabel = selectedItem.label ?? selectedItem.textContent?.trim() ?? '';
            }
        }

        // 2. Fall back to the event detail if the DOM read didn't yield a code.
        if (!selectedCode) {
            const selection = e?.detail?.value;
            if (Array.isArray(selection) && selection.length) {
                selectedCode = selection[0]?.value ?? '';
                selectedLabel = selection[0]?.label ?? '';
            } else if (selection && typeof selection === 'object') {
                selectedCode = selection.value ?? '';
                selectedLabel = selection.label ?? '';
            } else if (typeof selection === 'string') {
                selectedLabel = selection;
            }
        }

        // 3. Last resort: match by the displayed label.
        if (!selectedCode && selectedLabel) {
            const fallbackCountry = this.countryList.find((country: any) =>
                country.default === selectedLabel || country.title === selectedLabel
            );
            selectedCode = fallbackCountry?.code ?? '';
        }

        this.userOriginCountry = selectedCode;

        // If nothing was selected, don't treat it as an unsupported country
        if (!selectedCode) {
            return;
        }

        const selectedCountryDetails = this.countryList.find((country: any) => country.code === selectedCode);
        if (!selectedCountryDetails) {
            this.isSelectedCountrySupported = true;
            return;
        }
        if (!selectedCountryDetails?.isSupported) {
            this.isSelectedCountrySupported = true;
        }

        // Simulating a click event because the dropdown won't close otherwise
        setTimeout(() => {
            this.imageBackground?.nativeElement.click();
        }, 100);
    }

    onInputCountryChange(event: any) {
        if (event?.detail?.value === '' || event?.detail?.value == null) {
            this.userOriginCountry = '';
        }
    }

    onCheckBoxSelect(e: any) {
        this.hasUserConfirmedCountry = e?.detail?.checked;
    }

    onCountrySelectClick() {
        this.isLoginRedirectionInProgress = true;
        if (this.userOriginCountry && this.userOriginCountry !== '' && this.hasUserConfirmedCountry) {
            const countryDetails = this.countryList.find(country => country.code === this.userOriginCountry);
            if (countryDetails) {
                this._countrySelectionService.setCountry(JSON.stringify(countryDetails));
            } else {
                this.isLoginRedirectionInProgress = false;
                this.isSelectedCountrySupported = true;
            }
        } else {
            this.isLoginRedirectionInProgress = false;
        }
    }
}
